module.exports = __webpack_public_path__ + "img/fuel_economy.mars.df3f857.png";